export default __webpack_public_path__ + "static/media/DU-WOP.9facf321.jpg";